import {Observable} from 'rxjs';
import {Inject, Injectable} from '@angular/core';
import {AgreementPort} from '@features/agreement/application/ports/agreement.port';

import {ListAgreementUseCasePort} from '@features/agreement/application/use_cases/list-agreement/list-agreement.use-case.port';

import {ListAgreementResponseDto} from '@features/agreement/application/use_cases/list-agreement/dto/list-agreement.response.dto';
import {ListAgreementPayloadDto} from '@features/agreement/application/use_cases/list-agreement/dto/list-agreement.payload.dto';


@Injectable()
export class ListAgreementUseCase implements ListAgreementUseCasePort {

  constructor(
    @Inject(AgreementPort)
    private readonly port: AgreementPort
  ) {
  }

  public execute(payload: ListAgreementPayloadDto): Observable<ListAgreementResponseDto> {
    return this.port.listAgreement(payload);
  }
}
